import { Component, SimpleChanges } from '@angular/core';
import { Dossiers } from '../../../interfaces/Dossiers';
import { SharedService } from '../../../services/shared/shared.service';
import { SharedModule } from "../../../modules/shared/shared.module";
import { DashboardService } from '../../../services/dashboard/dashboard.service';
import { getElementsOnPage } from '../../../helpers/functions/GetElementsOnPage';

@Component({
  selector: 'app-dossiers-en-cours',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './dossiers-en-cours.component.html',
  styleUrl: './dossiers-en-cours.component.css'
})
export class DossiersEnCoursComponent 
{
  title:string = "Dossiers en cours" 
  pageSize:number = getElementsOnPage()
  pageIndex:number = 1
  totalPages!:number
  totalResult!:number
  // data_header_table = 
  // {
  //     "badge":"",
  //     "ref":"N°dossier MDE",
  //     "nom_dossier":"Nom du dossier",
  //     "num_contrat":"N°de contrat",
  //     "date":"Date saisine",
  //     "etat":"État",
  //     "hors_delai":"Hors délai"
  // }
  data_header_table = 
  {
    "badge":"",
    "ref":"N°dossier MDE",
    "nom_dossier":"Nom du dossier",
    "num_contrat":"N°de contrat",
    "date":"Date saisine",
    "etat":"État"
  }
  data_body_table: Dossiers[] = []
  isDataReady:boolean = false
  id_user!:number

  constructor
  (
    private sharedService:SharedService,
    private dashboardService: DashboardService
  ) 
  {
    const idUser = this.sharedService.getIdUser()
    this.id_user = idUser
    this.createPagination(this.pageSize)
  }

  ngOnInit()
  {
    this.getData()
  }

  ngOnChanges(changes: SimpleChanges) 
  {
    if ('search' in changes) 
    {
      this.getData()
    }
  }

  changePage(currentPage:number, pageSize:number=this.pageSize, changeDisplay:boolean=false)
  {  
    this.pageIndex = changeDisplay == false ? currentPage : 1 
    this.pageSize = pageSize
    this.getData()
  }

  async createPagination(pageSize:number)
  {
    (await
      this.sharedService.getInfoPagination("dossiers_en_cours", this.id_user)).subscribe(data => {
      this.totalResult = data[0].total_result
      this.totalPages = Math.ceil(this.totalResult / pageSize)
    })
  }

  getData(search:string="")
  {
    this.dashboardService.getDossiersEnCours(this.pageIndex, this.pageSize, this.id_user, search).subscribe((data:Dossiers[]) => {
      this.data_body_table = data
      this.isDataReady = true
    })
  }
}
